import React from "react";
import { Button, Chip } from "@mui/material";
import styles from "../../CaseActivityCard.module.css";

/**
 * EmailToolbar component
 *
 * Renders CASEACTIVITY_TYPE_NOTE rows with expand/collapse and delete support.
 */

function EmailToolbar({
  isEmailIn,
  isEmailOut,
  activity,
  replyToAll,
  onSetIsReplyPopupOpen,
  onHandleReplyWithTemplate,
  onHandleMarkUnread,
  numAttachments,
  onSetShowAttachments,
}) {
  const showReply = isEmailIn || isEmailOut;
  const canReplyAll =
    isEmailIn &&
    (activity.content.mail_content?.to?.length > 1 ||
      (activity.content.mail_content?.data?.cc &&
        (typeof activity.content.mail_content.data.cc === "string" ||
          activity.content.mail_content.data.cc.value?.length > 0)));

  return (
    <div className={styles.email_tools}>
      <Button
        data-testid="reply-button"
        className={
          showReply ? styles.btn_default : styles.btn_default_invisible
        }
        onClick={() => {
          replyToAll.current = false;
          onSetIsReplyPopupOpen(true);
        }}
      >
        Reply
      </Button>
      <Button
        data-testid="reply-with-template-button"
        className={
          showReply ? styles.btn_default : styles.btn_default_invisible
        }
        onClick={onHandleReplyWithTemplate}
      >
        Reply with template
      </Button>
      {canReplyAll && (
        <Button
          data-testid="reply-all-button"
          className={styles.btn_default}
          onClick={() => {
            replyToAll.current = true;
            onSetIsReplyPopupOpen(true);
          }}
        >
          Reply all
        </Button>
      )}
      <Button
        data-testid="mark-unread-button"
        className={
          isEmailIn ? styles.btn_default : styles.btn_default_invisible
        }
        onClick={onHandleMarkUnread}
      >
        Mark unread
      </Button>
      {numAttachments > 0 && (
        <div className={styles.attachment_button_container}>
          <Button
            data-testid="attachments-button"
            className={styles.btn_default}
            onClick={() => onSetShowAttachments(true)}
          >
            <Chip className={styles.attachment_chip} label={numAttachments} />
            Attachments
          </Button>
        </div>
      )}
    </div>
  );
}

export default EmailToolbar;
